import classNames from "classnames";
import React from "react";
import styles from "./SiteSectionIntro.scss";

/**
 * Centered eyebrow + title + lead used at the top of public page sections
 */
export const SiteSectionIntro = ({ eyebrow, title, lead, titleId, compact, className }) => {
    return (
        <div className={classNames(styles.base, { [styles.compact]: compact }, className)}>
            <p className={styles.eyebrow}>{eyebrow}</p>
            <h2 id={titleId} className={styles.title}>
                {title}
            </h2>
            {lead ? <p className={styles.lead}>{lead}</p> : null}
        </div>
    );
};
